export default "__VITE_ASSET__5c08fd39__"